export default {
  props: {
    value: null,
    multiple: {
      type: Boolean,
    },
    label: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
    },
    clearable: {
      type: Boolean,
    },
  },
  data() {
    return {
      loading: false,
      initialItems: [],
    };
  },
  computed: {
    catalogExists() {
      return Array.isArray(this.catalog) && this.catalog.length;
    },
    items() {
      return [...this.initialItems, ...this.catalog];
    },
  },
  watch: {
    value(newVal, oldVal) {
      if (newVal && oldVal) {
        return;
      }

      this.setInitialItems();
    },
  },
  mounted() {
    this.setInitialItems();
    this.fetchItems();
  },
  methods: {
    async fetchCatalog() {
      throw new Error(`fetchCatalog() is not defined in component`);
    },
    setInitialItems() {
      let items = [];

      if (this.value) {
        items = Array.isArray(this.value) ? this.value : [this.value];
      }

      this.initialItems = items;
    },
    fetchItems() {
      if (this.catalogExists) {
        return;
      }

      this.loading = true;

      return this.fetchCatalog()
        .catch(() => {
          this.$toast.error(`Не удалось загрузить список`);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleInput(value) {
      const valueToEmit = typeof value !== 'undefined' ? value : null;

      this.$emit('input', valueToEmit);
    },
    handleBlur(value) {
      this.$emit('blur', value || null);
    },
  },
};
